import { render, staticRenderFns } from "./LeftTree.vue?vue&type=template&id=990084a2&scoped=true"
import script from "./LeftTree.vue?vue&type=script&lang=js"
export * from "./LeftTree.vue?vue&type=script&lang=js"
import style0 from "./LeftTree.vue?vue&type=style&index=0&id=990084a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990084a2",
  null
  
)

export default component.exports